<template>
<md-card-content class="ql-cue-body">
    <form novalidate @submit.stop.prevent="submit" v-show="editing" @keyup.stop.prevent="keyPress">
        <md-input-container>
            <md-textarea v-model="cue.description"></md-textarea>
        </md-input-container>
        <md-button class="md-raised" @click="cancel">Cancel</md-button>
        <md-button class="md-raised md-primary" @click="done">Done</md-button>
    </form>
    <p v-if="editable" v-show="!editing" @click="edit" class="cue-description">
        <span v-show="cue.description">{{cue.description}}</span>
        <span v-show="!cue.description ">Click to enter text</span>
        <md-tooltip v-if="editable" md-direction="bottom">Click Text to Edit</md-tooltip>
    </p>
    <p v-else class="cue-description">
        <span>{{cue.description}}</span>
    </p>
    <md-button class="md-icon-button" v-if="!locked && !editing && editable" @click="destroy">
        <md-icon>delete</md-icon>
        <md-tooltip>Delete Cue</md-tooltip>
    </md-button>
</md-card-content>
</template>

<script>
/**
 * Component For...
 */
const ProjectCuesCueBody = {
    name: 'projectCuesCueBody',
    props: {
        cue: {Object},
        locked: {Boolean},
        editable: {Boolean},
        color: {String}
    },
    data: function() {
        return {
            editing: false,
            oldVal: this.$props.cue.description
        };
    },
    methods: {
        edit() {
            this.editing = true;
        },
        done() {
            this.editing = false;
            this.oldVal = this.cue.description;
            this.$emit('cueUpdated', this.cue);
        },
        cancel() {
            this.editing = false;
            this.cue.description = this.oldVal;
        },
        keyPress(e) {
            if (e.keyCode === 27) {
                this.done();
            }
        },
        destroy() {
            this.$emit('destroy');
        }
    },
    components: {
    }
};

export default ProjectCuesCueBody;
</script>

<style lang="scss">
.md-card-content {
    height: auto;
}
.ql-cue-body {
    box-sizing: border-box;
    .md-button {
        float: right;
    }

    .cue-description {
        white-space: pre-line;
    }

    form {
        .md-input-container {
            &.md-has-value {
                .md-input {
                    min-height: 72px;
                }
            }
        }
    }
}
</style>


// WEBPACK FOOTER //
// cue-body.vue?6fbd42c6